import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth'
import projects from './modules/projects'
import dashboard from './modules/dashboard'
import sidebar from './modules/sidebar'
import db_tables from './modules/db_tables'
import pages from './modules/pages'

Vue.use(Vuex);


const store = new Vuex.Store({
    modules: {
        auth,
        projects,
        dashboard,
        sidebar,
        db_tables,
        pages
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js